<template>
  <section class="uploader">
    <el-upload
      v-bind="$attrs"
      v-on="$listeners"
      list-type="picture-card"
      :show-file-list="false"
      :action="action"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :on-progress="handleProgress"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>
  </section>
</template>

<script>
import { Loading } from 'element-ui';
import { UPLOAD_FILE_API } from '@/api/global';

let loadingInstance;
let loadingTotal = 0;

export default {
  name: 'Uploader',
  components: {},
  mixins: [],
  props: {
    // 限制文件大小 MB
    limitSize: {
      type: Number,
      default: 1,
    },
    // 限制文件类型
    fileTypeLimit: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      action: UPLOAD_FILE_API,
    };
  },
  inheritAttrs: false,
  computed: {},
  watch: {},
  directives: {},
  filters: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    handleExceed(files, fileList) {
      const maxLeng = this.$attrs.limit - fileList.length;
      this.$message.warning(`最多还能上传${maxLeng}张图片`);
    },
    handleBeforeUpload(file) {
      this.startLoading();
      const { limitSize } = this;
      const isOverSize = file.size / 1024 / 1024 < limitSize;
      if (!isOverSize) {
        this.$message.error(`上传图片大小不能超过 ${limitSize}MB!`);
        this.endLoading();
        return false;
      }

      console.log(file);
      const fileName = file.name;
      const fileType = fileName.slice(fileName.lastIndexOf('.') + 1);
      const fileTypeLimit = this.fileTypeLimit ? this.fileTypeLimit.split('|') : [];
      // 校验文件 类型是否满足要起
      if (fileTypeLimit.length) {
        const flag = fileTypeLimit.some((it) => it === fileType);
        if (!flag) {
          this.uploadCode = 2;
          this.$message.error(`上传图片类型为${this.fileTypeLimit}`);
          this.endLoading();
          return false;
        }
      }
      return true;
    },
    handleSuccess(response, file, fileList) {
      this.endLoading();
      const { successful, statusCode } = response;
      if (successful || statusCode === 1) {
        // 将file 文件的url(blob类型的url) 转成 接口放回的 url
        // eslint-disable-next-line no-param-reassign
        file.url = response.data[0].url;
        this.$message.closeAll();
        this.$message.success('上传成功');
        this.$emit('update', fileList);
      } else {
        console.log('上传失败 =>>', response);
      }
    },
    handleProgress(e) {
      console.log('handleProgress =>>', e);
    },
    handleError(err, file) {
      console.log(err, file);
      this.endLoading();
    },
    startLoading(message = '正在上传...') {
      if (!loadingTotal) {
        loadingInstance = Loading.service({ text: message });
      }
      loadingTotal += 1;
    },
    endLoading() {
      loadingTotal -= 1;
      if (!loadingTotal && loadingInstance) {
        loadingInstance.close();
      }
    },
  },
};
</script>

<style lang="scss">
.uploader {
  &.exceed {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.uploader {
  display: inline-block;
  vertical-align: top;
  margin: 0 8px 8px 0;
}
</style>
